module.exports = __webpack_public_path__ + "static/media/php-expert.5eadedcc.png";